import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import uniqBy from "lodash/fp/uniqBy";

import shouldBeDisplayed from "./shouldBeDisplayed";

export default function getFilteredOptions({
  options = [],
  userChoiceValues = {},
}) {
  return flow(
    filter(shouldBeDisplayed(userChoiceValues)),
    uniqBy("value")
  )(options);
}
